import type { NavGroup, NavItem, NavRow } from '@/config/navigation';

/**
 * Pure nav helpers. A palette group renders EITHER a flat `items` list OR captioned `sections` (when `sections` is
 * used, `items` is `[]`); `flattenGroupItems` gives one item list regardless of which shape a group uses.
 */
export function flattenGroupItems(group: NavGroup): NavItem[] {
  if (group.sections?.length) return group.sections.flatMap((s) => s.items);
  return group.items;
}

/**
 * Id of the sidebar row whose href best matches the current route ('' when none does). The prototype's rule:
 * the longest href-prefix wins, so a deeper route beats its parent. `/` only ever matches itself:
 * `"/tasks".startsWith("//")` is false, which is what keeps Điều hành from lighting up on every screen.
 */
export function getActiveRowId(rows: readonly NavRow[], pathname: string): string {
  let best = { id: '', length: 0 };
  for (const row of rows) {
    const href = row.href.split('?')[0] ?? row.href;
    if ((pathname === href || pathname.startsWith(`${href}/`)) && href.length > best.length) {
      best = { id: row.id, length: href.length };
    }
  }
  return best.id;
}
